import IBookmark from '~/src/types/IBookmark';

export const adoptBookmarks = (
  bookmarks: Partial<IBookmark>[],
): IBookmark[] => {
  return bookmarks.map((bookmark: IBookmark) => {
    if (!bookmark.id) {
      return { ...bookmark, id: crypto.randomUUID() };
    } else {
      return bookmark;
    }
  });
};

// Union-merge: remote first, then local-only items (offline edits).
// Deletions made on another device can resurrect — accepted tradeoff.
export const mergeBookmarks = (
  remote: IBookmark[],
  local: IBookmark[],
): IBookmark[] => [
  ...remote,
  ...local.filter((b) => !remote.some((r) => r.id === b.id || r.url === b.url)),
];
